
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2022
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'createDashboardTitle': 'Create dashboard',
	'dashboard': 'Dashboard',
	'dashboardTemplate': 'Dashboard template',
	'createAV': 'Create',
	'createAvEditNameLabel': '1. Name your view',
	'createAvSelectTemplateLabel': '2. Select a template',
	'tabLayoutLabel': 'Tabbed template',
	'infographicsLayoutLabel': 'Infographic template',
	'singlePageLayoutLabel': 'Single page template',
	'customLayoutLabel': 'Custom template',
	'freeformTemplate': 'Freeform',
	'freeformTemplateDesc': 'Visualizations in a freeform layout appear exactly as you size and place them in the view, regardless of the screen size. In the other layouts, the size and position of visualizations adjust to fit into the screen.',
	'NoTemplate': 'Free form',
	'Template1': 'Blank',
	'Template2': 'Title 1 by 2',
	'Template3': '2 over 1',
	'Template4': '4 over 1',
	'Template5': 'Footer 1 by 2',
	'Template6': '3 beside 1 over 1',
	'Template7': '4 beside 3 over 1',
	'Template8': '2 over 3 by 2',
	'Template9': '2 by 2',
	'Template10': '1 by 2 beside 2 by 2 over 1',
	'Template11': '3 by 1 over 1 by 2',
	'Template12': '2 over 1 beside 1 by 2',
	'Template13': 'One beside 1 by 2 beside 1 by 4',
	'Template14': 'Blank with Dropzone',
	'Infographics1': 'Blank',
	'Infographics2': '4 rows',
	'Infographics3': '4 rows with headers',
	'Infographics4': '2 by 4',
	'Infographics5': 'Large top display with 2 by 2',
	'Infographics6': '2 by 4 with vertical gap',
	'Infographics7': '2 by 4 staggered',
	'Infographics8': 'Tennis court',
	'Infographics9': '3 by 4',
	'Infographics10': '4 by 8',
	'createAvDashboardLabel': 'Layout',
	'dashboard_template_save_success': 'Your dashboard template has been saved.',
	'dashboard_template_prefix': 'Template: "%{name}"',
	'dashboard_template_filters_removed': 'Filters on the canvas have been removed.',
	'createAvTabLabel': 'Tabbed',
	'createAvInfographicsLabel': 'Infographic',
	'createAvSinglepageLabel': 'Single Page',
	'createAvCustomLabel': 'Custom',
	'loadMoreLabel': 'Load more...',
	'backLabel': 'Go back',
	'addSourceLabel': 'Add a source',
	'pinLabel': 'Pin',
	'errorLoadingDataSetMetaData': 'An error occurred while reading the metadata',
	'errorLoadingDataSets': 'An error occurred while loading the list of data sets',
	'errorLoadingDataSet': 'The metadata for data set "%{datasetName}" did not load. Please contact your administrator for details.',
	'okButton': 'OK',
	'createButton': 'Create',
	'cancelButton': 'Cancel',
	'copyButton': 'Copy',
	'selectTemplateLabel': 'Select a template',
	'noSourcesSelectedLabel': 'No sources selected',
	'find_label': 'Find',
	'noDashboardFound': 'The dashboard cannot be retrieved. Either it no longer exists or you don\'t have sufficient privileges to view it.',
	'errorLabel': 'Error',
	'defaultName': 'New dashboard',
	'noDashboardCapability': 'You do not have the capability to run the dashboard application',
	'noCapabilityForEdit': 'You do not have the capability to edit this dashboard',
	'noCapabilityForSave': 'You do not have the capability to save this dashboard',
	'noCapabilityForPaste': 'You do not have the capability to paste copied widgets in this view',
	'noCapabilityForPin': 'You do not have the capability to add this pin',
	'noDashboardPermission': 'You do not have sufficient privileges to view this dashboard',
	'sourceNotFound': 'We can\'t load the visualization, because its associated source "%{sourceName}" isn\'t available',
	'cmDuplicateName': 'An item with this name already exists. Try another name',
	'cmEmptySelection': 'The dashboard has been deleted. Try to save as a new dashboard.',
	'propTheme': 'Visual theme',
	'defaultThemeLabel': 'Default',
	'lightThemeLabel': 'Light',
	'darkThemeLabel': 'Dark',
	'titleTextLabel': 'Title',
	'titleSmallTextLabel': 'Title Small',
	'subtitleTextLabel': 'Subtitle',
	'bodyTextLabel': 'Body',
	'bodySmallTextLabel': 'Body Small',
	'captionTextLabel': 'Caption',
	'quoteTextLabel': 'Quote',
	'quoteSmallTextLabel': 'Quote Small',
	'responsiveTextLabel': 'Auto-size',
	'mediaWidgetLabel': 'Media',
	'webpageWidgetLabel': 'Webpage',
	'imageWidgetLabel': 'Image',
	'textWidgetLabel': 'Text',
	'notebookWidgetLabel': 'Notebook',
	'multipurposeWidgetLabel': 'Multipurpose',
	'textPlaceHolder': 'Enter your text here',
	'titlePlaceHolder': 'Enter your title here',
	'toggleEditModeLabel': 'Switch to edit',
	'togglePreviewModeLabel': 'Switch to preview',
	'editDashboardCoachMarkTitle': 'Edit dashboard',
	'editDashboardCoachMarkContents': 'Click the pencil icon to edit this dashboard.',
	'addDataCoachMarkTitle': 'Add data',
	'addDataDashboardCoachMarkContents': 'Drag and drop data from the data panel onto your dashboard.',
	'pageSelectWarning': 'Please select a tab.',
	'screenshot_label': 'Dashboard %{title}',
	'screenshot_label_tab': 'Tab %{tabName} of dashboard %{title}',
	'dataAssetPropertiesLabel': 'Visualization properties',
	'modelFilter': 'Filter',
	'invertSelectionToolTip': 'Invert filter selections',
	'clearFilterValueToolTip': 'Clear filter values',
	'invertFilterSelection': 'Invert',
	'clearTextFilterValue': 'Clear',
	'filterConditionLabel': 'Filter condition',
	'applyFilter': 'Apply filter',
	'itemCountText': '%{itemCount} Item(s) selected',
	'itemExcludeCountText': '%{itemCount} Item(s) excluded',
	'moreMembers': 'Show more...',
	'searchHierarchyMembers': 'Use search to find members...',
	'propHideEmpty': 'Hide empty',
	'propColorOrder': 'Color order',
	'propElementColor': 'Visualization element color',
	'propLineColor': 'Line color',
	'propLineAndSymbolColor': 'Line and symbol color',
	'propColumnColor': 'Column color',
	'propBarColor': 'Bar color',
	'propWordColor': 'Word color',
	'propAreaColor': 'Area color',
	'propRadialbarColor': 'Radial bar color',
	'propColorPalettes': 'Color palettes',
	'propDashboardColorPalette': 'Current dashboard palette',
	'propNewDashboardPaletteLabel': 'Create a custom dashboard palette',
	'propDashboardChangePaletteLink': 'Change dashboard palette',
	'propHideLeafNode': 'Hide Lead Labels',
	'propOpacity': 'Opacity',
	'propOpacityDescription': 'Make the object more or less opaque. Type in a value between 0 and 100',
	'addATab': 'Add a new tab',
	'propFredIsRed': 'Color consistency',
	'areaChartCaption': 'Area',
	'areaChartDataSlot_categoriesLabel': 'Axis label',
	'areaChartDataSlot_valuesLabel': 'Value',
	'areaChartProp_colorPaletteLabel': 'Color palettes',
	'areaChartProp_lineColorLabel': 'Area color',
	'areaChartProp_interpolationLabel': 'Smooth lines',
	'areaChartProp_interpolationDescription': 'Lines connecting the data points are curved.',
	'areaChartProp_hideGridLinesLabel': 'Hide grid lines',
	'areaChartProp_hideGridLinesDescription': 'Hide grid lines',
	'areaChartProp_hideAxisTitleLabelsLabel': 'Hide axis title labels',
	'areaChartProp_hideAxisTitleLabelsDescription': 'Hide the titles for the axes.',
	'areaChartProp_maintainAxisScalesLabel': 'Maintain axis scale',
	'areaChartProp_maintainAxisScalesDescription': 'Always display the minimum and maximum values on the axes.',
	'areaChartProp_suppressZerosLabel': 'Hide empty',
	'areaChartProp_suppressZerosDescription': 'Hide categories with no associated values.',
	'barChartCaption': 'Bar',
	'barChartDataSlot_categoriesLabel': 'Axis label',
	'barChartDataSlot_valuesLabel': 'Value',
	'barChartProp_colorPaletteLabel': 'Color palettes',
	'barChartProp_elementColorLabel': 'Bar color',
	'barChartProp_hideGridLinesLabel': 'Hide grid lines',
	'barChartProp_hideGridLinesDescription': 'Hide grid lines',
	'barChartProp_hideAxisTitleLabelsLabel': 'Hide axis title labels',
	'barChartProp_hideAxisTitleLabelsDescription': 'Hide the titles for the axes.',
	'barChartProp_maintainAxisScalesLabel': 'Maintain axis scale',
	'barChartProp_maintainAxisScalesDescription': 'Always display the minimum and maximum values on the axes.',
	'barChartProp_suppressZerosLabel': 'Hide empty',
	'barChartProp_suppressZerosDescription': 'Hide categories with no associated values.',
	'columnChartCaption': 'Column',
	'columnChartDataSlot_categoriesLabel': 'Axis label',
	'columnChartDataSlot_valuesLabel': 'Value',
	'columnChartProp_colorPaletteLabel': 'Color palettes',
	'columnChartProp_elementColorLabel': 'Column color',
	'columnChartProp_hideGridLinesLabel': 'Hide grid lines',
	'columnChartProp_hideGridLinesDescription': 'Hide grid lines',
	'columnChartProp_hideAxisTitleLabelsLabel': 'Hide axis title labels',
	'columnChartProp_hideAxisTitleLabelsDescription': 'Hide the titles for the axes.',
	'columnChartProp_maintainAxisScalesLabel': 'Maintain axis scale',
	'columnChartProp_maintainAxisScalesDescription': 'Always display the minimum and maximum values on the axes.',
	'columnChartProp_suppressZerosLabel': 'Hide empty',
	'columnChartProp_suppressZerosDescription': 'Hide categories with no associated values.',
	'bubbleChartCaption': 'Bubble',
	'bubbleChartDataSlot_xAxisLabel': 'Horizontal axis',
	'bubbleChartDataSlot_yAxisLabel': 'Vertical axis',
	'bubbleChartDataSlot_sizeLabel': 'Size by',
	'bubbleChartDataSlot_colorLabel': 'Color by',
	'bubbleChartProp_colorPaletteLabel': 'Color palettes',
	'bubbleChartProp_hideGridLinesLabel': 'Hide grid lines',
	'bubbleChartProp_hideGridLinesDescription': 'Hide grid lines',
	'bubbleChartProp_hideAxisTitleLabelsLabel': 'Hide axis title labels',
	'bubbleChartProp_hideAxisTitleLabelsDescription': 'Hide the titles for the axes.',
	'bubbleChartProp_maintainAxisScalesLabel': 'Maintain axis scale',
	'bubbleChartProp_maintainAxisScalesDescription': 'Always display the minimum and maximum values on the axes.',
	'bubbleChartProp_hideLegendLabel': 'Hide legend',
	'bubbleChartProp_hideLegendDescription': 'Hide the legend.',
	'bubbleChartProp_legendPositionLabel': 'Legend position',
	'lineChartCaption': 'Line',
	'lineChartDataSlot_categoriesLabel': 'Axis label',
	'lineChartDataSlot_valuesLabel': 'Value',
	'lineChartProp_colorPaletteLabel': 'Color palettes',
	'lineChartProp_lineColorLabel': 'Line and symbol color',
	'lineChartProp_symbolShapeLabel': 'Symbol shape',
	'lineChartProp_hideSymbolsLabel': 'Hide Symbols',
	'lineChartProp_hideSymbolsDescription': 'Hide symbols',
	'lineChartProp_hideDataLinesLabel': 'Hide line(s)',
	'lineChartProp_hideDataLinesDescription': 'Hide line(s)',
	'lineChartProp_interpolationLabel': 'Smooth lines',
	'lineChartProp_interpolationDescription': 'Lines connecting the data points are curved.',
	'lineChartProp_hideGridLinesLabel': 'Hide grid lines',
	'lineChartProp_hideGridLinesDescription': 'Hide grid lines',
	'lineChartProp_hideAxisTitleLabelsLabel': 'Hide axis title labels',
	'lineChartProp_hideAxisTitleLabelsDescription': 'Hide the titles for the axes.',
	'lineChartProp_maintainAxisScalesLabel': 'Maintain axis scale',
	'lineChartProp_maintainAxisScalesDescription': 'Always display the minimum and maximum values on the axes.',
	'lineChartProp_suppressZerosLabel': 'Hide empty',
	'lineChartProp_suppressZerosDescription': 'Hide categories with no associated values.',
	'packedBubbleChart1CatCaption': 'Packed bubble',
	'packedBubbleChart1CatDataSlot_categoriesLabel': 'Categories',
	'packedBubbleChart1CatDataSlot_sizeLabel': 'Size by',
	'packedBubbleChart1CatProp_colorPaletteLabel': 'Color palettes',
	'packedBubbleChart1CatProp_elementColorLabel': 'Bubble color',
	'packedBubbleChart1CatProp_hideLabelLabel': 'Hide label',
	'packedBubbleChart1CatProp_hideValueLabel': 'Hide value',
	'packedBubbleChart1CatProp_maintainAxisScalesLabel': 'Maintain axis scale',
	'packedBubbleChart1CatProp_maintainAxisScalesDescription': 'Always display the minimum and maximum values on the axes.',
	'packedBubbleChart1CatProp_suppressZerosLabel': 'Hide empty',
	'packedBubbleChart1CatProp_suppressZerosDescription': 'Hide categories with no associated values.',
	'heatChartCaption': 'Heat',
	'heatChartDataSlot_valuesLabel': 'Heat by',
	'heatChartDataSlot_xAxisLabel': 'Horizontal axis',
	'heatChartDataSlot_yAxisLabel': 'Vertical axis',
	'heatChartProp_colorPaletteLabel': 'Color palettes',
	'heatChartProp_heatScalePaletteLabel': 'Color order',
	'heatChartProp_hideAxisTitleLabelsLabel': 'Hide axis title labels',
	'heatChartProp_hideAxisTitleLabelsDescription': 'Hide the titles for the axes.',
	'heatChartProp_maintainAxisScalesLabel': 'Maintain axis scale',
	'heatChartProp_maintainAxisScalesDescription': 'Always display the minimum and maximum values on the axes.',
	'heatChartProp_suppressZerosLabel': 'Hide empty',
	'heatChartProp_suppressZerosDescription': 'Hide categories with no associated values.',
	'heatChartProp_hideLegendLabel': 'Hide legend',
	'heatChartProp_hideLegendDescription': 'Hide the legend.',
	'heatChartProp_legendPositionLabel': 'Legend position',
	'pieChartCaption': 'Pie',
	'pieChartDataSlot_categoriesLabel': 'Categories',
	'pieChartDataSlot_valuesLabel': 'Value',
	'pieChartProp_colorPaletteLabel': 'Color palettes',
	'pieChartProp_hideRadialValueLabel': 'Hide value',
	'pieChartProp_pieAsDonutLabel': 'Display as donut chart',
	'pieChartProp_pieAsDonutDescription': 'Display as donut chart',
	'pieChartProp_suppressZerosLabel': 'Hide empty',
	'pieChartProp_suppressZerosDescription': 'Hide categories with no associated values.',
	'pieChartProp_hideLegendLabel': 'Hide legend',
	'pieChartProp_hideLegendDescription': 'Hide the legend.',
	'pieChartProp_legendPositionLabel': 'Legend position',
	'map1measureCaption': 'Map',
	'map1measureDataSlot_categoriesLabel': 'Regions',
	'map1measureDataSlot_valuesLabel': 'Region heat',
	'map1measureProp_colorPaletteLabel': 'Color palettes',
	'map1measureProp_heatScalePaletteLabel': 'Color order',
	'map1measureProp_maintainAxisScalesLabel': 'Maintain axis scale',
	'map1measureProp_maintainAxisScalesDescription': 'Always display the minimum and maximum values on the axes.',
	'map1measureProp_suppressZerosLabel': 'Hide empty',
	'map1measureProp_suppressZerosDescription': 'Hide categories with no associated values.',
	'map1measureProp_hideLegendLabel': 'Hide legend',
	'map1measureProp_hideLegendDescription': 'Hide the legend.',
	'map1measureProp_legendPositionLabel': 'Legend position',
	'radialChartCaption': 'Radial',
	'radialChartDataSlot_categoriesLabel': 'Categories',
	'radialChartDataSlot_valuesLabel': 'Value',
	'radialChartProp_colorPaletteLabel': 'Color palettes',
	'radialChartProp_elementColorLabel': 'Radial bar color',
	'radialChartProp_hideRadialTitleLabel': 'Hide title',
	'radialChartProp_hideRadialValueLabel': 'Hide value',
	'radialChartProp_maintainAxisScalesLabel': 'Maintain axis scale',
	'radialChartProp_maintainAxisScalesDescription': 'Always display the minimum and maximum values on the axes.',
	'radialChartProp_suppressZerosLabel': 'Hide empty',
	'radialChartProp_suppressZerosDescription': 'Hide categories with no associated values.',
	'pointChart1catCaption': 'Point',
	'pointChart1catDataSlot_valuesLabel': 'Value',
	'pointChart1catDataSlot_categoriesLabel': 'Axis label',
	'pointChart1catProp_colorPaletteLabel': 'Color palettes',
	'pointChart1catProp_elementColorLabel': 'Shape color',
	'pointChart1catProp_symbolShapeLabel': 'Symbol shape',
	'pointChart1catProp_symbolFillLabel': 'Fill shape',
	'pointChart1catProp_symbolFillDescription': 'Display fill color for the symbols.',
	'pointChart1catProp_hideGridLinesLabel': 'Hide grid lines',
	'pointChart1catProp_hideGridLinesDescription': 'Hide grid lines',
	'pointChart1catProp_hideAxisTitleLabelsLabel': 'Hide axis title labels',
	'pointChart1catProp_hideAxisTitleLabelsDescription': 'Hide the titles for the axes.',
	'pointChart1catProp_maintainAxisScalesLabel': 'Maintain axis scale',
	'pointChart1catProp_maintainAxisScalesDescription': 'Always display the minimum and maximum values on the axes.',
	'pointChart1catProp_suppressZerosLabel': 'Hide empty',
	'pointChart1catProp_suppressZerosDescription': 'Hide categories with no associated values.',
	'scatterPlotChartNoCatCaption': 'Scatter plot',
	'scatterPlotChartNoCatDataSlot_xAxisLabel': 'Horizontal axis',
	'scatterPlotChartNoCatDataSlot_yAxisLabel': 'Vertical axis',
	'scatterPlotChartNoCatProp_colorPaletteLabel': 'Color palettes',
	'scatterPlotChartNoCatProp_elementColorLabel': 'Element color',
	'scatterPlotChartNoCatProp_symbolShapeLabel': 'Symbol shape',
	'scatterPlotChartNoCatProp_symbolFillLabel': 'Fill shape',
	'scatterPlotChartNoCatProp_symbolFillDescription': 'Display fill color for the symbols.',
	'scatterPlotChartNoCatProp_hideGridLinesLabel': 'Hide grid lines',
	'scatterPlotChartNoCatProp_hideGridLinesDescription': 'Hide grid lines',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel': 'Hide axis title labels',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription': 'Hide the titles for the axes.',
	'radialBarChartCaption': 'Radial bar',
	'radialBarChartDataSlot_categoriesLabel': 'Categories',
	'radialBarChartDataSlot_valuesLabel': 'Value',
	'radialBarChartProp_colorPaletteLabel': 'Color palettes',
	'radialBarChartProp_elementColorLabel': 'Radial bar color',
	'radialBarChartProp_hideRadialTitleLabel': 'Hide title',
	'radialBarChartProp_maintainAxisScalesLabel': 'Maintain axis scale',
	'radialBarChartProp_maintainAxisScalesDescription': 'Always display the minimum and maximum values on the axes.',
	'radialBarChartProp_suppressZerosLabel': 'Hide empty',
	'radialBarChartProp_suppressZerosDescription': 'Hide categories with no associated values.',
	'lineColumnComboChartCaption': 'Line and column',
	'lineColumnComboChartDataSlot_categoryLabel': 'Axis label',
	'lineColumnComboChartDataSlot_lineValueLabel': 'Line value',
	'lineColumnComboChartDataSlot_columnValueLabel': 'Column value',
	'lineColumnComboChartProp_colorPaletteLabel': 'Color palettes',
	'lineColumnComboChartProp_elementColorLabel': 'Column color',
	'lineColumnComboChartProp_lineColorLabel': 'Line and symbol color',
	'lineColumnComboChartProp_symbolShapeLabel': 'Symbol shape',
	'lineColumnComboChartProp_hideSymbolsLabel': 'Hide symbols',
	'lineColumnComboChartProp_hideSymbolsDescription': 'Hide symbols',
	'lineColumnComboChartProp_hideDataLinesLabel': 'Hide line(s)',
	'lineColumnComboChartProp_hideDataLinesDescription': 'Hide line(s)',
	'lineColumnComboChartProp_interpolationLabel': 'Smooth lines',
	'lineColumnComboChartProp_interpolationDescription': 'Lines connecting the data points are curved.',
	'lineColumnComboChartProp_hideGridLinesLabel': 'Hide grid lines',
	'lineColumnComboChartProp_hideGridLinesDescription': 'Hide grid lines',
	'lineColumnComboChartProp_hideAxisTitleLabelsLabel': 'Hide axis title labels',
	'lineColumnComboChartProp_hideAxisTitleLabelsDescription': 'Hide the titles for the axes.',
	'lineColumnComboChartProp_maintainAxisScalesLabel': 'Maintain axis scale',
	'lineColumnComboChartProp_maintainAxisScalesDescription': 'Always display the minimum and maximum values on the axes.',
	'lineColumnComboChartProp_suppressZerosLabel': 'Hide empty',
	'lineColumnComboChartProp_suppressZerosDescription': 'Hide categories with no associated values.',
	'lineColumnComboChartProp_hideLegendLabel': 'Hide legend',
	'lineColumnComboChartProp_hideLegendDescription': 'Hide the legend.',
	'lineColumnComboChartProp_legendPositionLabel': 'Legend position',
	'summaryCaption': 'Summary',
	'areaName': 'Area',
	'areaDescription': 'Area',
	'areaDataSlot_colorLabel': 'Color by',
	'areaDataSlot_valuesLabel': 'Value',
	'areaDataSlot_categoriesLabel': 'Axis label',
	'bubbleName': 'Bubble',
	'bubbleDescription': 'Bubble',
	'bubbleDataSlot_yAxisLabel': 'Vertical axis',
	'bubbleDataSlot_xAxisLabel': 'Horizontal axis',
	'bubbleDataSlot_sizeLabel': 'Size by',
	'bubbleDataSlot_colorLabel': 'Color by',
	'clusterBarName': 'Bar',
	'clusterBarDescription': 'Bar',
	'clusterBarDataSlot_colorLabel': 'Color by',
	'clusterBarDataSlot_valuesLabel': 'Value',
	'clusterBarDataSlot_categoriesLabel': 'Axis label',
	'clusterBarDataSlot_valuesRepeatingLabel': 'Value',
	'clusterColumnName': 'Column',
	'clusterColumnDescription': 'Column',
	'clusterColumnDataSlot_colorLabel': 'Color by',
	'clusterColumnDataSlot_valuesLabel': 'Value',
	'clusterColumnDataSlot_categoriesLabel': 'Axis label',
	'clusterColumnDataSlot_valuesRepeatingLabel': 'Value',
	'clusterLineName': 'Line',
	'clusterLineDescription': 'Line',
	'clusterLineDataSlot_colorLabel': 'Color by',
	'clusterLineDataSlot_valuesLabel': 'Vertical axis',
	'clusterLineDataSlot_categoriesLabel': 'Horizontal axis',
	'clusterLineDataSlot_valuesRepeatingLabel': 'Value',
	'gridName': 'Grid',
	'gridDescription': 'Grid',
	'gridDataSlot_grid_colsLabel': 'Column',
	'heatName': 'Heat',
	'heatDescription': 'Heat',
	'heatDataSlot_yAxisLabel': 'Vertical axis',
	'heatDataSlot_xAxisLabel': 'Horizontal axis',
	'heatDataSlot_valuesLabel': 'Heat by',
	'lineColumnComboName': 'Line and column',
	'lineColumnComboDescription': 'Line and column',
	'lineColumnComboDataSlot_lineValueLabel': 'Line value',
	'lineColumnComboDataSlot_categoryLabel': 'Axis label',
	'lineColumnComboDataSlot_columnValueLabel': 'Column value',
	'mapName': 'Legacy Map',
	'mapDescription': 'Legacy Map',
	'mapDataSlot_sizeLabel': 'Point size',
	'mapDataSlot_valuesLabel': 'Region heat',
	'mapDataSlot_sizeHeatLabel': 'Point heat',
	'mapDataSlot_categoriesLabel': 'Regions',
	'packedBubbleName': 'Packed bubble',
	'packedBubbleDescription': 'Packed bubble',
	'packedBubbleDataSlot_sizeLabel': 'Size by',
	'packedBubbleDataSlot_colorLabel': 'Color by',
	'packedBubbleDataSlot_categoriesLabel': 'Categories',
	'pieName': 'Pie',
	'pieDescription': 'Pie',
	'pieDataSlot_valuesLabel': 'Value',
	'pieDataSlot_categoriesLabel': 'Categories',
	'playerName': 'Data player',
	'playerDescription': 'Data player',
	'playerDataSlot_categoriesLabel': 'Axis label',
	'pointName': 'Point',
	'pointDescription': 'Point',
	'pointDataSlot_colorLabel': 'Color by',
	'pointDataSlot_valuesLabel': 'Value',
	'pointDataSlot_categoriesLabel': 'Axis label',
	'radialName': 'Radial',
	'radialDescription': 'Radial',
	'radialDataSlot_valuesLabel': 'Value',
	'radialDataSlot_maxSizeLabel': 'Maximum value',
	'radialDataSlot_categoriesLabel': 'Categories',
	'radialBarName': 'Radial bar',
	'radialBarDescription': 'Radial bar',
	'radialBarDataSlot_valuesLabel': 'Value',
	'radialBarDataSlot_categoriesLabel': 'Categories',
	'scatterPlotName': 'Scatter plot',
	'scatterPlotDescription': 'Scatter plot',
	'scatterPlotDataSlot_yAxisLabel': 'Vertical axis',
	'scatterPlotDataSlot_xAxisLabel': 'Horizontal axis',
	'scatterPlotDataSlot_colorLabel': 'Color by',
	'scatterPlotDataSlot_categoriesLabel': 'Points',
	'stackedBarName': 'Stack bar',
	'stackedBarDescription': 'Stack bar',
	'stackedBarDataSlot_colorLabel': 'Color by',
	'stackedBarDataSlot_valuesLabel': 'Value',
	'stackedBarDataSlot_categoriesLabel': 'Axis label',
	'stackedBarDataSlot_valuesRepeatingLabel': 'Value',
	'stackedColumnName': 'Stack column',
	'stackedColumnDescription': 'Stack column',
	'stackedColumnDataSlot_colorLabel': 'Color by',
	'stackedColumnDataSlot_valuesLabel': 'Value',
	'stackedColumnDataSlot_categoriesLabel': 'Axis label',
	'stackedColumnDataSlot_valuesRepeatingLabel': 'Value',
	'summaryChartName': 'Summary',
	'summaryChartDescription': 'Summary',
	'summaryChartDataSlot_valuesLabel': 'Value',
	'treeMapName': 'Tree map',
	'treeMapDescription': 'Tree map',
	'treeMapDataSlot_colorLabel': 'Heat by',
	'treeMapDataSlot_valuesLabel': 'Size by',
	'treeMapDataSlot_categoriesLabel': 'Level one',
	'treeMapDataSlot_level3Label': 'Level three',
	'treeMapDataSlot_level2Label': 'Level two',
	'wordCloudName': 'Word cloud',
	'wordCloudDescription': 'Word cloud',
	'wordCloudDataSlot_colorLabel': 'Color by',
	'wordCloudDataSlot_scaleLabel': 'Size by',
	'wordCloudDataSlot_wordLabel': 'Words',
	'treeMap1Cat1MeasureChartCaption': 'Tree map',
	'treeMap1Cat1MeasureChartDataSlot_categoriesLabel': 'Level one',
	'treeMap1Cat1MeasureChartDataSlot_valuesLabel': 'Size by',
	'treeMap1Cat1MeasureChartProp_colorPaletteLabel': 'Color palettes',
	'treeMap1Cat2MeasureChartProp_colorPaletteLabel': 'Color palettes',
	'treeMap2Cat1MeasureChartProp_colorPaletteLabel': 'Color palettes',
	'treeMap2Cat2MeasureChartProp_colorPaletteLabel': 'Color palettes',
	'treeMap3Cat1MeasureChartProp_colorPaletteLabel': 'Color palettes',
	'treeMap3Cat2MeasureChartProp_colorPaletteLabel': 'Color palettes',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel': 'Maintain axis scale',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription': 'Always display the minimum and maximum values on the axes.',
	'treeMap1Cat1MeasureChartProp_suppressZerosLabel': 'Hide empty',
	'treeMap1Cat1MeasureChartProp_suppressZerosDescription': 'Hide categories with no associated values.',
	'treeMap1Cat1MeasureChartProp_hideLegendLabel': 'Hide legend',
	'treeMap1Cat1MeasureChartProp_hideLegendDescription': 'Hide the legend.',
	'treeMap1Cat1MeasureChartProp_legendPositionLabel': 'Legend position',
	'wordChart1Cat1MeasureCaption': 'Word cloud',
	'wordChart1Cat1MeasureDataSlot_wordLabel': 'Words',
	'wordChart1Cat1MeasureDataSlot_scaleLabel': 'Size by',
	'wordChart1Cat1MeasureProp_colorPaletteLabel': 'Color palettes',
	'wordChart1Cat1MeasureProp_elementColorLabel': 'Word color',
	'wordChart1Cat1MeasureProp_maintainAxisScalesLabel': 'Maintain axis scale',
	'wordChart1Cat1MeasureProp_maintainAxisScalesDescription': 'Always display the minimum and maximum values on the axes.',
	'wordChart1Cat1MeasureProp_suppressZerosLabel': 'Hide empty',
	'wordChart1Cat1MeasureProp_suppressZerosDescription': 'Hide categories with no associated values.',
	'missingDataSetData': 'The data for this data set is not available. Refresh the data set or contact your administrator for access to the source.',
	'hideShowSummaries': 'Hide show summaries',
	'crosstabName': 'Crosstab',
	'value_is_not_available': 'N/A',
	'swapRowsAndColumns': 'Swap rows and columns',
	'NoPinsCollected': 'No pinned visualizations',
	'pinSearchOld': 'Search my pins',
	'pinDeletedToast': 'Pin was removed',
	'pinAddedToast': 'Pin was successfully added to My pins',
	'pinRetrieveError': 'We can\'t retrieve one or more pins. Try again later.',
	'pinErrorTitle': 'Pinning Error',
	'pinRemove': 'Remove the pin',
	'deletePin': 'Delete the pin',
	'dataset_time': 'time',
	'dataset_date': 'date',
	'dataset_location': 'location',
	'dataset_number': 'number',
	'dataset_text': 'text',
	'widgetConditionalFormatLabel': 'Toggle conditional format controls',
	'deletePinConfirmationMessage': 'Are you sure you want to delete this pin? This cannot be undone.',
	'deletePinConfirm': 'Confirm delete',
	'pinDeleteError': 'We can\'t delete one or more pins. Try again later.',
	'conditionalPalettePickerLabel': 'Distribution of %{title} values',
	'HistogramYAxisTitle': 'Count',
	'metadataPickerTitle': 'Create Data Set',
	'moreTitle': 'More',
	'remove_slider_handle': 'Remove handle',
	'missingFiltering': 'Column missing:',
	'unSupportedPromptType': 'The prompt scenario is not currently supported.',
	'preAggregateLabel': 'Apply prompt values from the data source',
	'postAggregateLabel': 'Apply prompt values in the report',
	'preAggregateText': 'The range uses the values in the data source, not the values displayed in the dashboard.',
	'tabName_general': 'General',
	'tabName_visDetails': 'Details',
	'tabName_textDetails': 'Text details',
	'tabName_mediaDetails': 'Media details',
	'tabName_webDetails': 'Web page details',
	'tabName_imageDetails': 'Image details',
	'tabName_visualization': 'Visualization',
	'sectionName_canvas': 'Canvas',
	'sectionName_colorsAndThemes': 'Color and theme',
	'sectionName_appearance': 'Appearance',
	'sectionName_advanced': 'Advanced',
	'sectionName_layout': 'Layout',
	'sectionName_tabs': 'Tabs',
	'sectionName_tabTitle': 'Label',
	'sectionName_tabBackground': 'Background',
	'addDataSourceDialogTitle': 'Add a data source',
	'addDataSourceDialogButtonLabel': 'Add',
	'shapesDoubleChevron': 'Double chevron',
	'widgetsPanelTitle': 'Widgets',
	'widgetsPanelImageLibraryTab': 'Image library',
	'widgetsPanelSectionBasic': 'Basic',
	'widgetsPanelSectionAdvanced': 'Advanced',
	'widgetsPanelSectionShapes': 'Shapes',
	'customWidgetsTitle': 'Custom widgets',
	'filterItemCanvasMove': 'Add to canvas',
	'filterOverflowMenu_Global': 'All tabs overflow menu',
	'filterOverflowMenu_Tab': 'This tab overflow menu',
	'filterOverflowMenu_Item': 'Filter overflow menu',
	'filterOverflowMenu_Single': 'Overflow menu',
	'filterItemEdit': 'Edit filter values',
	'filterDeleteAllItems': 'Delete all filters',
	'filterClearAllItems': 'Clear all filters',
	'filterClearSelection': 'Clear filter',
	'filterPlayerMode': 'Show player',
	'filterStaticMode': 'Show list',
	'filterInvertSelection': 'Invert filter',
	'filterIconLabel_Global': 'All tabs',
	'filterIconLabel_Single': 'Filters',
	'filterIconLabel_Tab': 'This tab',
	'filterIconTooltip_Global': 'All tabs',
	'filterIconTooltip_Tab': 'This tab',
	'filterIconTooltip_Single': 'Filters',
	'filterItemDelete': 'Delete filter',
	'filterValueSeparator': ',',
	'filterRange': '%{from}-%{to}',
	'filterInvertRange': 'everything except: %{from}-%{to}',
	'filterExcept': 'except %{values}',
	'filterAll': 'All',
	'filterBlank': '(blank)',
	'filterDisableRangeInvert': 'Unavailable when this column is in "All tabs" filter.',
	'filterDisableHierarchyInvert': 'Unavailable when this column is a hierarchy filter.',
	'filterSelectedOfTotal': '%{selected} of %{totalMembers}',
	'filter_date_before': 'Before %{to}',
	'filter_date_before_except': 'Not before %{to}',
	'filter_date_after': 'After %{from}',
	'filter_date_after_except': 'Not after %{from}',
	'filter_date_between': 'Between %{from}-%{to}',
	'filter_date_between_except': 'Not between %{from}-%{to}',
	'filter_drag_and_drop_all_tabs': 'Drag and drop data here to filter all tabs.',
	'filter_drag_and_drop_current_tab': 'Drag and drop data here to filter this tab.',
	'filter_drag_and_drop_single_dock': 'Drag and drop data here to filter.',
	'errMsgFilterItemGenericTitle': 'Filter values can\'t be loaded',
	'widgetChromeRotate': 'Rotate',
	'toolbarRegionLabel': 'Toolbar',
	'toolbarActionDelete': 'Delete',
	'toolbarActionGroup': 'Group',
	'toolbarActionUngroup': 'Ungroup',
	'toolbarActionOrderToFront': 'Send to front',
	'toolbarActionOrderToBack': 'Send to back',
	'toolbarActionEditTitle': 'Edit the title',
	'toolbarActionWrapTitle': 'Wrap the title',
	'toolbarActionPin': 'Collect',
	'toolbarActionPinOld': 'Pin',
	'toolbarActionAlign': 'Align',
	'alignWidgetLeft': 'Left',
	'alignWidgetCenter': 'Center',
	'alignWidgetRight': 'Right',
	'alignWidgetTop': 'Top',
	'alignWidgetMiddle': 'Middle',
	'alignWidgetBottom': 'Bottom',
	'toolbarChangeVisualization': 'Change visualization',
	'live_label': 'Chart',
	'filter_label': 'Filter',
	'one_named_live': '%{name} chart',
	'one_named_live_numbered': '%{name} chart (%{number})',
	'one_unknown_live': 'Chart',
	'one_unknown_live_numbered': 'Chart (%{number})',
	'few_live': 'Group of %{count} charts',
	'many_live': 'Group of %{count} charts',
	'one_custom': 'Custom widget',
	'one_custom_named': '%{name}',
	'one_custom_named_numbered': '%{name} (%{number})',
	'one_named_filter': '%{name} filter',
	'one_named_filter_numbered': '%{name} filter (%{number})',
	'one_unknown_filter': 'Filter',
	'one_unknown_filter_numbered': 'Filter (%{number})',
	'few_filter': 'Group of %{count} filters',
	'many_filter': 'Group of %{count} filters',
	'LIVE_bar_has_mapping': '%{values} bar chart',
	'LIVE_bar_has_mapping_numbered': '%{values} bar chart (%{number})',
	'LIVE_bar_opt_mapping': '%{categories} by %{values} bar chart',
	'LIVE_bar_opt_mapping_numbered': '%{categories} by %{values} bar chart (%{number})',
	'LIVE_bar_no_mapping': 'Empty bar chart',
	'LIVE_bar_no_mapping_numbered': 'Empty bar chart (%{number})',
	'LIVE_bar_named': '%{name} bar chart',
	'LIVE_bar_named_numbered': '%{name} bar chart (%{number})',
	'LIVE_stacked_bar_has_mapping': '%{values} stacked bar chart',
	'LIVE_stacked_bar_has_mapping_numbered': '%{values} stacked bar chart (%{number})',
	'LIVE_stacked_bar_opt_mapping': '%{categories} by %{values} stacked bar chart',
	'LIVE_stacked_bar_opt_mapping_numbered': '%{categories} by %{values} stacked bar chart (%{number})',
	'LIVE_stacked_bar_no_mapping': 'Empty stacked bar chart',
	'LIVE_stacked_bar_no_mapping_numbered': 'Empty stacked bar chart (%{number})',
	'LIVE_stacked_bar_named': '%{name} stacked bar chart',
	'LIVE_stacked_bar_named_numbered': '%{name} stacked bar chart (%{number})',
	'LIVE_bubble_has_mapping': '%{categories} by %{x} and %{y} bubble chart',
	'LIVE_bubble_has_mapping_numbered': '%{categories} by %{x} and %{y} bubble chart (%{number})',
	'LIVE_bubble_no_mapping': 'Empty bubble chart',
	'LIVE_bubble_no_mapping_numbered': 'Empty bubble chart (%{number})',
	'LIVE_bubble_named': '%{name} bubble chart',
	'LIVE_bubble_named_numbered': '%{name} bubble chart (%{number})',
	'LIVE_composite_has_mapping': '%{categories} by %{columnValue} and %{lineValue} composite chart',
	'LIVE_composite_has_mapping_numbered': '%{categories} by %{columnValue} and %{lineValue} composite chart (%{number})',
	'LIVE_composite_no_mapping': 'Empty composite chart',
	'LIVE_composite_no_mapping_numbered': 'Empty composite chart (%{number})',
	'LIVE_composite_named': '%{name} composite chart',
	'LIVE_composite_named_numbered': '%{name} composite chart (%{number})',
	'LIVE_decision_tree_has_mapping': '%{values} decision tree',
	'LIVE_decision_tree_has_mapping_numbered': '%{values} decision tree (%{number})',
	'LIVE_decision_tree_no_mapping': 'Empty decision tree',
	'LIVE_decision_tree_no_mapping_numbered': 'Empty decision tree (%{number})',
	'LIVE_decision_tree_named': '%{name} decision tree',
	'LIVE_decision_tree_named_numbered': '%{name} decision tree (%{number})',
	'LIVE_packed_bubble_has_mapping': '%{categories} packed bubble chart',
	'LIVE_packed_bubble_has_mapping_numbered': '%{categories} packed bubble chart (%{number})',
	'LIVE_packed_bubble_no_mapping': 'Empty packed bubble chart',
	'LIVE_packed_bubble_no_mapping_numbered': 'Empty packed bubble chart (%{number})',
	'LIVE_packed_bubble_named': '%{name} packed bubble chart',
	'LIVE_packed_bubble_named_numbered': '%{name} packed bubble chart (%{number})',
	'LIVE_pie_has_mapping': '%{categories} by %{values} pie chart',
	'LIVE_pie_has_mapping_numbered': '%{categories} by %{values} pie chart (%{number})',
	'LIVE_pie_no_mapping': 'Empty pie chart',
	'LIVE_pie_no_mapping_numbered': 'Empty pie chart (%{number})',
	'LIVE_pie_named': '%{name} pie chart',
	'LIVE_pie_named_numbered': '%{name} pie chart (%{number})',
	'LIVE_pie_as_donut_has_mapping': '%{categories} by %{values} donut chart',
	'LIVE_pie_as_donut_has_mapping_numbered': '%{categories} by %{values} donut chart (%{number})',
	'LIVE_pie_as_donut_no_mapping': 'Empty donut chart',
	'LIVE_pie_as_donut_no_mapping_numbered': 'Empty donut chart (%{number})',
	'LIVE_pie_as_donut_named': '%{name} donut chart',
	'LIVE_pie_as_donut_named_numbered': '%{name} donut chart (%{number})',
	'LIVE_line_has_mapping': '%{categories} by %{values} line chart',
	'LIVE_line_has_mapping_numbered': '%{categories} by %{values} line chart (%{number})',
	'LIVE_line_no_mapping': 'Empty line chart',
	'LIVE_line_no_mapping_numbered': 'Empty line chart (%{number})',
	'LIVE_line_named': '%{name} line chart',
	'LIVE_line_named_numbered': '%{name} line chart (%{number})',
	'LIVE_area_has_mapping': '%{categories} by %{values} area chart',
	'LIVE_area_has_mapping_numbered': '%{categories} by %{values} area chart (%{number})',
	'LIVE_area_no_mapping': 'Empty area chart',
	'LIVE_area_no_mapping_numbered': 'Empty area chart (%{number})',
	'LIVE_area_named': '%{name} area chart',
	'LIVE_area_named_numbered': '%{name} area chart (%{number})',
	'LIVE_area_as_stacked_percent_has_mapping': '%{categories} by %{values} stacked percent area chart',
	'LIVE_area_as_stacked_percent_has_mapping_numbered': '%{categories} by %{values} stacked percent area chart (%{number})',
	'LIVE_area_as_stacked_percent_no_mapping': 'Empty stacked percent area chart',
	'LIVE_area_as_stacked_percent_no_mapping_numbered': 'Empty stacked percent area chart (%{number})',
	'LIVE_area_as_stacked_percent_named': '%{name} stacked percent area chart',
	'LIVE_area_as_stacked_percent_named_numbered': '%{name} stacked percent area chart (%{number})',
	'LIVE_heatmap_has_mapping': '%{color} heat map',
	'LIVE_heatmap_has_mapping_numbered': '%{color} heat map (%{number})',
	'LIVE_heatmap_no_mapping': 'Empty heat map',
	'LIVE_heatmap_no_mapping_numbered': 'Empty heat map (%{number})',
	'LIVE_heatmap_named': '%{name} heat map',
	'LIVE_heatmap_named_numbered': '%{name} heat map (%{number})',
	'LIVE_network_opt_mapping': '%{categories} by %{series} and %{values} network',
	'LIVE_network_opt_mapping_numbered': '%{categories} by %{series} and %{values} network (%{number})',
	'LIVE_network_has_mapping': '%{categories} by %{series} network',
	'LIVE_network_has_mapping_numbered': '%{categories} by %{series} network (%{number})',
	'LIVE_network_no_mapping': 'Empty network',
	'LIVE_network_no_mapping_numbered': 'Empty network (%{number})',
	'LIVE_network_named': '%{name} network',
	'LIVE_network_named_numbered': '%{name} network (%{number})',
	'LIVE_radial_bar_opt_mapping': '%{categories} by %{values} radial bar chart',
	'LIVE_radial_bar_opt_mapping_numbered': '%{categories} by %{values} radial bar chart (%{number})',
	'LIVE_radial_bar_has_mapping': '%{values} radial bar chart',
	'LIVE_radial_bar_has_mapping_numbered': '%{values} radial bar chart (%{number})',
	'LIVE_radial_bar_no_mapping': 'Empty radial bar chart',
	'LIVE_radial_bar_no_mapping_numbered': 'Empty radial bar chart (%{number})',
	'LIVE_radial_bar_named': '%{name} radial bar chart',
	'LIVE_radial_bar_named_numbered': '%{name} radial bar chart (%{number})',
	'LIVE_spiral_has_mapping': '%{values} spiral chart',
	'LIVE_spiral_has_mapping_numbered': '%{values} spiral chart (%{number})',
	'LIVE_spiral_no_mapping': 'Empty spiral chart',
	'LIVE_spiral_no_mapping_numbered': 'Empty spiral chart (%{number})',
	'LIVE_spiral_named': '%{name} spiral chart',
	'LIVE_spiral_named_numbered': '%{name} spiral chart (%{number})',
	'LIVE_treemap_has_mapping': '%{categories} by %{size} tree map',
	'LIVE_treemap_has_mapping_numbered': '%{categories} by %{size} tree map (%{number})',
	'LIVE_treemap_no_mapping': 'Empty tree map',
	'LIVE_treemap_no_mapping_numbered': 'Empty tree map (%{number})',
	'LIVE_treemap_named': '%{name} tree map',
	'LIVE_treemap_named_numbered': '%{name} tree map (%{number})',
	'LIVE_wordcloud_has_mapping': '%{categories} word cloud',
	'LIVE_wordcloud_has_mapping_numbered': '%{categories} word cloud (%{number})',
	'LIVE_wordcloud_no_mapping': 'Empty word cloud',
	'LIVE_wordcloud_no_mapping_numbered': 'Empty word cloud (%{number})',
	'LIVE_wordcloud_named': '%{name} word cloud',
	'LIVE_wordcloud_named_numbered': '%{name} word cloud (%{number})',
	'LIVE_data_player_has_mapping': '%{category} data player',
	'LIVE_data_player_has_mapping_numbered': '%{category} data player (%{number})',
	'LIVE_data_player_no_mapping': 'Empty data player',
	'LIVE_data_player_no_mapping_numbered': 'Empty data player (%{number})',
	'LIVE_data_player_named': '%{name} data player',
	'LIVE_data_player_named_numbered': '%{name} data player (%{number})',
	'LIVE_map_has_mapping': '%{locations} map',
	'LIVE_map_has_mapping_numbered': '%{locations} map (%{number})',
	'LIVE_map_no_mapping': 'Empty map',
	'LIVE_map_no_mapping_numbered': 'Empty map (%{number})',
	'LIVE_map_named': '%{name} map',
	'LIVE_map_named_numbered': '%{name} map (%{number})',
	'LIVE_point_has_mapping': '%{categories} by %{values} point chart',
	'LIVE_point_has_mapping_numbered': '%{categories} by %{values} point chart (%{number})',
	'LIVE_point_no_mapping': 'Empty point chart',
	'LIVE_point_no_mapping_numbered': 'Empty point chart (%{number})',
	'LIVE_point_named': '%{name} point chart',
	'LIVE_point_named_numbered': '%{name} point chart (%{number})',
	'LIVE_column_has_mapping': '%{values} column chart',
	'LIVE_column_has_mapping_numbered': '%{values} column chart (%{number})',
	'LIVE_column_opt_mapping': '%{categories} by %{values} column chart',
	'LIVE_column_opt_mapping_numbered': '%{categories} by %{values} column chart (%{number})',
	'LIVE_column_no_mapping': 'Empty column chart',
	'LIVE_column_no_mapping_numbered': 'Empty column chart (%{number})',
	'LIVE_column_named': '%{name} column chart',
	'LIVE_column_named_numbered': '%{name} column chart (%{number})',
	'LIVE_stacked_column_has_mapping': '%{values} stacked column chart',
	'LIVE_stacked_column_has_mapping_numbered': '%{values} stacked column chart (%{number})',
	'LIVE_stacked_column_opt_mapping': '%{categories} by %{values} stacked column chart',
	'LIVE_stacked_column_opt_mapping_numbered': '%{categories} by %{values} stacked column chart (%{number})',
	'LIVE_stacked_column_no_mapping': 'Empty stacked column chart',
	'LIVE_stacked_column_no_mapping_numbered': 'Empty stacked column chart (%{number})',
	'LIVE_stacked_column_named': '%{name} stacked column chart',
	'LIVE_stacked_column_named_numbered': '%{name} stacked column chart (%{number})',
	'LIVE_scatter_opt_mapping': '%{categories} by %{x} and %{y} scatter plot',
	'LIVE_scatter_opt_mapping_numbered': '%{categories} by %{x} and %{y} scatter plot (%{number})',
	'LIVE_scatter_has_mapping': '%{x} vs %{y} scatter plot',
	'LIVE_scatter_has_mapping_numbered': '%{x} vs %{y} scatter plot (%{number})',
	'LIVE_scatter_no_mapping': 'Empty scatter plot',
	'LIVE_scatter_no_mapping_numbered': 'Empty scatter plot (%{number})',
	'LIVE_scatter_named': '%{name} scatter plot',
	'LIVE_scatter_named_numbered': '%{name} scatter plot (%{number})',
	'LIVE_waterfall_has_mapping': '%{values} waterfall chart',
	'LIVE_waterfall_has_mapping_numbered': '%{values} waterfall chart (%{number})',
	'LIVE_waterfall_no_mapping': 'Empty waterfall chart',
	'LIVE_waterfall_no_mapping_numbered': 'Empty waterfall chart (%{number})',
	'LIVE_waterfall_named': '%{name} waterfall chart',
	'LIVE_waterfall_named_numbered': '%{name} waterfall chart (%{number})',
	'LIVE_empty_visualization_hint_title': 'Build your visualization',
	'LIVE_empty_visualization_hint_description': 'Drag and drop columns here or onto the slots to the left.',
	'LIVE_slots_required_field_description': '%{asterisk} Indicates a required field',
	'LIVE_slots_drag_and_drop_description': 'Drag and drop data to the slots above to build and filter the visualization.',
	'requiredField': 'Required Field',
	'fullScreenEnter': 'Enter full screen',
	'fullScreenClose': 'Exit full screen',
	'noExtraText_multipurpose': 'Multipurpose placeholder',
	'noExtraText_multipurpose_numbered': 'Multipurpose placeholder (%{number})',
	'one_placeholder_vis': 'Visualization placeholder',
	'one_placeholder_vis_numbered': 'Visualization placeholder (%{number})',
	'one_placeholder_text': 'Text placeholder',
	'one_placeholder_text_numbered': 'Text placeholder (%{number})',
	'few_placeholder_text': 'Group of %{count} text placeholders',
	'many_placeholder_text': 'Group of %{count} text placeholders',
	'filter_includesAll': 'Includes all',
	'timeline_filter_moved_to': 'Time line filter %{id} moved to %{time}',
	'timelineSettingsButton': 'Playback options',
	'autoPlay': 'Play all scenes',
	'loop': 'Loop',
	'noSceneTransitionLabel': 'None',
	'sceneTransitionPropertyLabel': 'Scene transition',
	'animatedPathSceneTransitionLabel': 'Animated path',
	'sweepSceneTransitionLabel': 'Sweep',
	'propAniAnimation': 'Animation',
	'propAniTypeEntrance': 'Entrance animation',
	'propAniDirectionIn': 'Entrance direction',
	'propAniTypeExit': 'Exit animation',
	'propAniDirectionOut': 'Exit direction',
	'propAniDirection': 'Direction',
	'timelineAnimationProperties': 'Open animation properties',
	'editStoryCoachMarkTitle': 'Edit story',
	'editStoryCoachMarkContents': 'Click the pencil icon to edit this story.',
	'addDataStoryCoachMarkContents': 'Drag and drop data from the data panel onto your story.',
	'expandSceneCoachmarkTitle': 'Open timeline',
	'expandSceneCoachmarkContents': 'Animate a scene by adjusting object visibility based on time and duration.',
	'overviewCoachmarkTitle': 'Overview scenes',
	'overviewCoachmarkContents': 'Use the overview scenes at the start and end of your story to show the big picture of all the scenes. From an overview scene, click and drag a scene to swap it with another scene. You can show or hide the overview scenes in the story properties.',
	'animatedPathCoachmarkTitle': 'Animated path',
	'animatedPathCoachmarkContents': 'To animate an object from one scene to another, duplicate a scene with an object. Then, move, resize, or rotate the duplicated object on the new scene.',
	'tabName_animation': 'Animation',
	'textWidgetIconPlaceholderText': 'Click to add text',
	'visIconPlaceholderText': 'Drag and drop data to build a visualization',
	'launchNewExplore': 'New exploration',
	'addTo': 'Add to',
	'addToExisting': 'Add to existing...',
	'exploreData': 'Explore',
	'explore_remove_widget_styles': 'Custom visualization properties such as color settings will not persist in your exploration.',
	'editNotebook': 'Edit Widget',
	'thumbnails_error_fetching': 'Error fetching thumbnails',
	'copy': '%{count} asset(s) copied',
	'specConvertErr': 'An error occurred pasting or converting the dashboard specification',
	'specCopyErr': 'Error copying dashboard specification',
	'pasteNotSupportedErr': 'Pasting from a %{name} is not supported.',
	'reportParam': 'report',
	'filterWidgetCopyWarn': 'Filter visualization was not copied because Filters are not supported at this time.',
	'upgradingDashboard': 'Upgrading "%{name}" for %{version}...',
	'upgradeComplete': 'Upgrade complete',
	'individualTabProperties': 'Individual tab properties',
	'propMasterTabStylesLabel': 'Master tab styling',
	'propTabPosition': 'Tab position',
	'propTabTitle': 'Title',
	'propTabBackgroundColor': 'Fill color',
	'propTabTextColor': 'Title color',
	'propTabSelectedBarColor': 'Selected bar color',
	'propTabRestoreDefaults': 'Restore defaults',
	'propIndividualTabStylesLabel': 'Individual tab styling',
	'propIndividualTabStylesAriaLabel': 'Open individual tab styling properties',
	'propTabIconPosition': 'Icon position',
	'propLeftTitle': 'Left of title',
	'propRightTitle': 'Right of title',
	'propTopTitle': 'Above title',
	'propBottomTitle': 'Below title',
	'propTabIconLabel': 'Visual',
	'propTabIcon': 'Icon',
	'propTabIconColor': 'Icon color',
	'no_icon': 'Empty',
	'announcement': 'Announcement',
	'api': 'Api',
	'archive': 'Archive',
	'asset': 'Asset',
	'attachment': 'Attachment',
	'audio': 'Audio',
	'bee': 'Bee',
	'blog': 'Blog',
	'bookmark': 'Bookmark',
	'calendar': 'Calendar',
	'camera': 'Camera',
	'capability': 'Capability',
	'catalog': 'Catalog',
	'chat_message': 'Chat message',
	'checkout_cart': 'Checkout cart',
	'client': 'Client',
	'clock': 'Clock',
	'cloud': 'Cloud',
	'code': 'Code',
	'data_quality': 'Data quality',
	'folder': 'Folders',
	'forum': 'Forum',
	'glasses': 'Glasses',
	'group': 'Group',
	'hat': 'Hat',
	'headphone': 'Headphone',
	'hills': 'Hills',
	'home': 'Home',
	'idea': 'Idea',
	'image': 'Image',
	'inventory': 'Inventory',
	'like': 'Like',
	'link': 'Link',
	'location': 'Location',
	'manage': 'Manage',
	'pen': 'Pen',
	'mobile_phone': 'Mobile phone',
	'music': 'Music',
	'notifications': 'Notifications',
	'paint': 'Paint',
	'payment': 'Payment',
	'password_key': 'Password key',
	'people': 'People',
	'person': 'Person',
	'phone': 'Phone',
	'pin': 'Pin',
	'print': 'Print',
	'recording': 'Recording',
	'repository': 'Repository',
	'role': 'Role',
	'search': 'Search',
	'properties': 'Properties',
	'speaker': 'Speaker',
	'star': 'Star',
	'tag': 'Tag',
	'thumbs_up': 'Thumbs up',
	'thumbs_down': 'Thumbs down',
	'tools': 'Tools',
	'traffic': 'Traffic',
	'trash': 'Trash',
	'twitter': 'Twitter',
	'unknown': 'Unknown',
	'user': 'User',
	'venn_diagram': 'Venn diagram',
	'video': 'Video',
	'view': 'View',
	'warning': 'Warning',
	'watch': 'Watch',
	'watson': 'Watson',
	'wikis': 'Wikis',
	'workspace': 'Workspace',
	'world': 'World',
	'OnLoadFilterModifierDatasourceMismatch': 'Filters will not be applied to the target because the dashboards are using different sources.',
	'OnLoadFilterModifierColumnMismatch': 'One or more filters were not applied because the matching column(s) could not be found.',
	'eventGroupButtonLabel': 'View widget connections',
	'dockToolbar': 'Dock toolbar',
	'undockToolbar': 'Undock toolbar',
	'propShowTitle': 'Show title'
});
